export enum ApiRequestStatus {
    Idle,
    Pending,
    Fulfilled,
    Rejected
}